import { render, staticRenderFns } from "./loadingData.vue?vue&type=template&id=4cc02a24&scoped=true"
import script from "./loadingData.vue?vue&type=script&lang=js"
export * from "./loadingData.vue?vue&type=script&lang=js"
import style0 from "./loadingData.vue?vue&type=style&index=0&id=4cc02a24&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc02a24",
  null
  
)

export default component.exports